import { Paper, Table, Title, createStyles } from "@mantine/core"
import { useMedplum } from "@medplum/react";
import { useParams } from "react-router-dom";


const useStyles = createStyles((theme) => ({
    table: {
     marginTop: "30px"
   },
    thead: {
        backgroundColor: '#BEDEF8',
        borderRadius: 4,
    },
 }));

 const sampleData = [
    {
        name: "Team 1",
        role: "Hospital",
        email: "team1@care.com",
        category: "Cordination",
        contact: "-",
        id:"1141211"
    },
    {
        name: "Team 2",
        role: "Family",
        email: "team2@care.com",
        category: "Cordination",
        contact: "-",
        id:"114211"
    }
 ]
export const CareTeam = () => {
    const {patientId} = useParams()
    const { classes } = useStyles();
    const medplum = useMedplum();
    const tableHeaders = ["Name", "Role", "Category", "Email", "Contact"]


    return (
        <>
            <Paper
                sx={{
                    marginTop: "20px",
                    borderRadius: "8px",
                    marginLeft: "0px",
                    marginRight: "0px",
                    padding: "20px",
                    background: "'#FFF",
                    boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
                }}
                withBorder
            >
                <Title>
                    Observation
                </Title>
                <Table className={classes.table}>
          <thead className={classes.thead}>
            <tr>
                {
                    tableHeaders.map((val)=>{
                        return (
                            <th key={val}>
                                {val}
                            </th>
                        )
                    })
                }
            </tr>
          </thead>
          {
            <tbody>
              {/* {
                careTeamData.map((data:any) => (
                  <tr key={data.id}>
                    <td>{data.name}</td>
                    <td>{data.role}</td>
                    <td>{data.category}</td>
                    <td>{data.email}</td>
                    <td>{data.contact}</td>
                  </tr>
                ))
              } */}
            </tbody>
          }
        </Table>
            </Paper>
        </>
    )
}